import { Component, OnInit } from '@angular/core';
import { InternalSettings } from 'src/app/common/services/internal-settings/internal-settings.interface';
import { InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { ResponsiveDesignService } from '../../services/responsive-design/responsive-design.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';
import { combineLatest } from 'rxjs';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.less'],
    standalone: false
})
export class UserInfoComponent implements OnInit {

  UIUtilityService: any= UIUtilityService;
  internalSettings!: InternalSettings | null;
  externalSettings!: ExternalSettings | null;

  constructor(
    public translate: TranslateUtilityService,
    private srvIS: InternalSettingsService, 
    private srvES: ExternalSettingsService,
    private srvRpDesign: ResponsiveDesignService)
  {}

  ngOnInit(): void {
    combineLatest([
      this.srvIS.getCurrentSettings(),
      this.srvES.externalSettings$,
    ]).subscribe(([internalSettings, externalSettings]) => {
      this.internalSettings = internalSettings;
      this.externalSettings = externalSettings;
    });
  }

  toggleSidebar(): void {
    this.srvRpDesign.setSidebarNav(true);
  }


}
